<script setup lang="ts">
    import { ChevronRight } from 'lucide-vue-next';
    import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
    import { Voucher } from '@/types';
    import { computed } from 'vue';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { useVoucherStore } from '@/stores/voucher';

    const { t } = useI18n();

    const voucherStore = useVoucherStore();

    const props = defineProps<{
        selectedVouchers: Voucher[];
    }>();

    const invalidVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => !voucher.valid_for_marking_as_missing),
    );

    const validVouchers = computed(() =>
        props.selectedVouchers.filter((voucher) => voucher.valid_for_marking_as_missing),
    );

    const markAsMissing = () => {
        if (invalidVouchers.value.length) {
            toast.error(t('vouchers.select.mark_as_missing_confirm.invalid_header'), {
                description: t('vouchers.select.mark_as_missing_confirm.invalid_description', {
                    body: invalidVouchers.value
                        .map((voucher) => `#${voucher.VoucherNumber}`)
                        .join(', '),
                }),
            });
            return;
        }

        voucherStore.setValidVouchers(validVouchers.value);
        voucherStore.toggleOpen('mark_as_missing', true);
    };
</script>

<template>
    <DropdownMenuItem @click="markAsMissing">
        {{ t('vouchers.select.mark_as_missing') }}
        <ChevronRight class="text-primary" />
    </DropdownMenuItem>
</template>
